export default "__VITE_ASSET__qPmRcrQm__";